import { render, staticRenderFns } from "./SelectBrand.vue?vue&type=template&id=311d480e"
import script from "./SelectBrand.vue?vue&type=script&lang=js"
export * from "./SelectBrand.vue?vue&type=script&lang=js"
import style0 from "./SelectBrand.vue?vue&type=style&index=0&id=311d480e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports